import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import moment from 'moment'
import modalHistoricoPontuacaoModule from './modal-historico-pontuacao.module'
import FinanceiroStore from '../RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component({
  ...modalHistoricoPontuacaoModule,
})
export default class ComponentModalHistoricoPontuacao extends Vue {
  activeTab = 'tab-0'

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  close() {
    this.getShowModalHistorico = false
  }

  get history() {
    return this.getHistoricoSituacaoStore.historicoPontuacao
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getShowModalHistorico() {
    return this.getHistoricoSituacaoStore.modalPontuacao.historicoPontuacao
  }

  set getShowModalHistorico(value: boolean) {
    this.getHistoricoSituacaoStore.clearhistoricoSituacao()
    this.getHistoricoSituacaoStore.setShowModalHistoricoPontuacao(value)
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  pontuacaoHistoricoHeader: any[] = [
    { text: 'Criado por', value: 'createdByNome', align: 'center', sortable: false },
    { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Nome profissional', value: 'profissionalNome', align: 'center', sortable: false },
    { text: 'Pontuação anterior nome', value: 'PontuacaoAnteriorNome', align: 'center', sortable: false },
    { text: 'Pontuação nova nome', value: 'PontuacaoNovaNome', align: 'center', sortable: false },
  ]

  /**
   * Paginação
   */

  get itemsLength() {
    return Math.ceil(this.getHistoricoSituacaoStore.totalItems / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getHistoricoSituacaoStore.pagina
  }

  set getPagina(value: number) {
    this.getHistoricoSituacaoStore.setPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    const id = this.getHistoricoSituacaoStore.idForLoadItems
    await this.getHistoricoSituacaoStore.getHistoricoPontuacao(id)
    this.loadingDataTable = false
  }
}
